export default __webpack_public_path__ + "static/media/longchamp31.bbf39214.jpg";